/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import ReactDOM from "react-dom/client";
import { posthog } from "posthog-js";
import reportWebVitals from "./reportWebVitals";
import ProjectRoutes from "./projectRoutes/ProjectRoutes";
import { trackVisibilityChanges } from "./utils/util";
import './global.css';

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, { api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST });
// Track a page view
if (process.env.REACT_APP_NODE.ENV === 'production') {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
    // Add other console methods if needed
  }
posthog.capture("$pageview");
trackVisibilityChanges()
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<ProjectRoutes />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
